import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class QuickPanelService {

  comunicacionNotificacion = new BehaviorSubject('');
  comunicacionHistorialNotificacion = new BehaviorSubject('');

  actualizaNotif = this.comunicacionNotificacion.asObservable();
  actualizaHistorialNotif = this.comunicacionHistorialNotificacion.asObservable();

  comunicacionIcoNot = new BehaviorSubject(false);
  muestraIcoNot = this.comunicacionIcoNot.asObservable();

  constructor(
    private http: HttpClient
  ) { }

  enviaToolbar(datos:any){
    // console.log("envia info a toolbar");
    this.comunicacionNotificacion.next(datos);
  }

  enviaHistorial(datos:any){
    // console.log("envia info a toolbar");
    this.comunicacionHistorialNotificacion.next(datos);
  }

  muestraIcoNotif(datos:any){
    this.comunicacionIcoNot.next(datos);
  }

  getNotificaciones(){
    let datos = {limite: 10, instituto: localStorage.getItem('instituto')};
    if(datos.instituto== "0"){
      localStorage.setItem('instituto_id',''+0);
    }
    // console.log("datosGetnot:",datos);

    return this.http.post(DATOS_API.url + DATOS_API.endpoints.notificaciones.get, datos);
  }

  updateNotificacion(status:boolean, vivo:number, idNotif:string){
    let datos = {status,vivo};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.notificaciones.update + idNotif, datos);
  }

  getNotificacionesEmpresaID(productoId){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.notificaciones.getNotificacionesEmpresa+productoId);
  }

  updateNotificacionEstatus(productoId:any, idNotif:any,datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.updateVivoNotificacion +productoId+"/"+ idNotif, datos);
  }

}
